import Rector from "../assets/askofu3.png";
import { images } from "../constants";
import { useEffect, useState } from "react";
import axiosInstance from "../AxiosInstance";
import { useTranslation } from "react-i18next";

const Organization = () => {

    const [organizationData, setOrganizationData] = useState([]);
     const [loading, setLoading] = useState(true);

    const { t } = useTranslation();

     useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const response = await axiosInstance.get("/files/page/ORGANIZATION");
        const organizationData = response.data
          //.filter(photo => photo.page === "ORGANIZATION")
          .sort((a, b) => new Date(b.date) - new Date(a.date));
        setOrganizationData(organizationData);
      } catch (error) {
        console.error("Failed to fetch photos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPhotos();
  }, []);


    return (
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 px-4 lg:px-10 mt-0  dark:bg-gray-800">

            {/* First Portion (3 grid) */}
            <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
                <h1 className="text-3xl sm:text-xl lg:text-2xl text-center font-bold tracking-wide text-gray-900 dark:text-white mb-6">
                    {t("alevel.schoolName")}{" "}
                    <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text block mt-2">
                        {t("alevel.schoolSub")}
                    </span>
                </h1>
                <img
                    src={images.visigalogo}
                    alt="Visiga Seminary Logo"
                    className="mt-4 w-40 h-auto rounded-full border-4 border-white dark:border-gray-700 shadow-md hover:scale-105 transition-transform duration-300"
                />
            </div>

            {/* Middle Portion (6 grid) */}
            <div className="lg:col-span-6 flex flex-col items-center mt-1 lg:mt-5  dark:bg-gray-800  dark:text-gray-100">


                <h1 className="text-3xl sm:text-4xl lg:text-2xl text-center tracking-wide mt-5 dark:text-gray-100">
                    {t("organization.title")} {""}
                    <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text">
                        {t("organization.subtitle")}
                    </span>
                </h1>


                {/* ASKOFU MKUU */}
                <div className="flex justify-center w-full mt-5">
                    {organizationData
                        .filter(org => org.title === "ARCHBISHOP") // Filter for Archbishop role
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl || images.Askofu} // Fallback to default image
                                    alt="Archbishop"
                                    style={{ width: "4cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name || "Bishop Jude Thadeus Ruwaichi"}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description || "Archbishop of Dar es Salaam"}
                                </span>
                            </div>
                        ))}
                </div>
                {/* ASKOFU MSAIDIZI */}
                <div className="flex justify-center w-full mt-5">
                   <div>
                    {organizationData
                        .filter(org => org.title === "AUXILIARYBISHOP-1") // Filter for Archbishop role
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl} 
                                    alt="Archbishop"
                                    style={{ width: "4cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}
                    </div>
                    <div>
                    {organizationData
                        .filter(org => org.title === "AUXILIARYBISHOP-2") 
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl} 
                                    alt="Archbishop"
                                    style={{ width: "4cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}
                    </div>
                    
                </div>



                <div className="flex justify-center w-full mt-5">
                    {/* Rector */}
                    {organizationData
                        .filter(org => org.title === "RECTOR") // Filter for Archbishop role
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl} // Fallback to default image
                                    alt="Archbishop"
                                    style={{ width: "4cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}
                </div>


                <div className="flex justify-between w-full mt-5">

                    {organizationData
                        .filter(org => org.title === "SPIRITUAL-DIRECTOR")
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl}
                                    alt="Archbishop"
                                    style={{ width: "4cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}

                    {organizationData
                        .filter(org => org.title === "ACADEMIC-DEAN")
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl}
                                    alt="Archbishop"
                                    style={{ width: "4cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}


                    {organizationData
                        .filter(org => org.title === "DISCIPLINE-MASTER")
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl}
                                    alt="Archbishop"
                                    style={{ width: "4cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}

                        {organizationData
                        .filter(org => org.title === "GUARDIAN-TEACHER")
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl}
                                    alt="Archbishop"
                                    style={{ width: "4cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}
                </div>

                <div className="flex justify-between w-full mt-5">
                    {organizationData
                        .filter(org => org.title === "TEACHER")
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl}
                                    alt="Archbishop"
                                    style={{ width: "4cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}

                    {organizationData
                        .filter(org => org.title === "ACCOUNTANT")
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl}
                                    alt="Archbishop"
                                    style={{ width: "4cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}


                    {organizationData
                        .filter(org => org.title === "HEAD-CHEF")
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl}
                                    alt="Archbishop"
                                    style={{ width: "4cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}


                </div>

                <div className="lg:col-span-3 bg-gray-100 p-4 flex flex-col items-center dark:bg-gray-800 dark:text-gray-100">
                    <h1 className="text-3xl sm:text-xl lg:text-2xl text-center tracking-wide">
                        {t("organization.teacher")}
                    </h1>
                </div>
                <div className="flex justify-between w-full mt-5">
                    {/* Archbishop */}
                    {organizationData
                        .filter(org => org.title === "ACADEMIC")
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl}
                                    alt="Archbishop"
                                    style={{ width: "4cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}

                    {organizationData
                        .filter(org => org.title === "STAFFS")
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl}
                                    alt="Archbishop"
                                    style={{ width: "7cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}
                    {organizationData
                        .filter(org => org.title === "ASSISTANT-ACADEMIC")
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl}
                                    alt="Archbishop"
                                    style={{ width: "4cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}
                </div>

                <div className="lg:col-span-3 bg-gray-100 p-4 flex flex-col items-center dark:bg-gray-800 dark:text-gray-100">
                    <h1 className="text-3xl sm:text-xl lg:text-2xl text-center tracking-wide">
                        {t("organization.project")}
                    </h1>
                </div>
                <div className="flex justify-between w-full mt-5">
                    {/* Archbishop */}
                    {organizationData
                        .filter(org => org.title === "PROJECT-MANAGER")
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl}
                                    alt="Archbishop"
                                    style={{ width: "4cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}

                    {organizationData
                        .filter(org => org.title === "PROJECT-TEAM")
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl}
                                    alt="Archbishop"
                                    style={{ width: "7cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}
                    {organizationData
                        .filter(org => org.title === "ASSISTANT-PROJECT-MANAGER")
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl}
                                    alt="Archbishop"
                                    style={{ width: "4cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}
                </div>


                <div className="lg:col-span-3 bg-gray-100 p-4 flex flex-col items-center dark:bg-gray-800 dark:text-gray-100">
                    <h1 className="text-3xl sm:text-xl lg:text-2xl text-center tracking-wide">
                        {t("organization.dispensary")}
                    </h1>
                </div>
                <div className="flex justify-between w-full mt-5">
                    {/* Archbishop */}
                    {organizationData
                        .filter(org => org.title === "DISPENSARY-MANAGER")
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl}
                                    alt="Archbishop"
                                    style={{ width: "4cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}

                    {organizationData
                        .filter(org => org.title === "DISPENSARY-TEAM")
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl}
                                    alt="Archbishop"
                                    style={{ width: "7cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}
                    {organizationData
                        .filter(org => org.title === "ASSISTANT-DISPENSARY-MANAGER")
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl}
                                    alt="Archbishop"
                                    style={{ width: "4cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}
                </div>

                <div className="lg:col-span-3 bg-gray-100 p-4 flex flex-col items-center dark:bg-gray-800 dark:text-gray-100">
                    <h1 className="text-3xl sm:text-xl lg:text-2xl text-center tracking-wide">
                        {t("organization.staffs")}
                    </h1>
                </div>
                <div className="flex justify-between w-full mt-5">
                    {/* Archbishop */}
                    {organizationData
                        .filter(org => org.title === "DRIVERS")
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl}
                                    alt="Archbishop"
                                    style={{ width: "4cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}

                    {organizationData
                        .filter(org => org.title === "CHEF-TEAM")
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl}
                                    alt="Archbishop"
                                    style={{ width: "7cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}
                    {organizationData
                        .filter(org => org.title === "OTHER")
                        .map((organization) => (
                            <div key={organization.id} className="flex flex-col items-center">
                                <img
                                    className="rounded-md border border-neutral-300"
                                    src={organization.photoUrl}
                                    alt="Archbishop"
                                    style={{ width: "4cm", height: "5cm", objectFit: "cover" }}
                                />
                                <h6 className="text-neutral-900 dark:text-gray-100 mt-2">
                                    {organization.name}
                                </h6>
                                <span className="text-sm font-normal italic text-neutral-900 dark:text-gray-100">
                                    {organization.description}
                                </span>
                            </div>
                        ))}
                </div>

            </div>

            {/* Third Portion (3 grid) */}
            <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
                <img
                    src={images.hailmary3}
                    alt="Hail Mary"
                    className="w-full h-auto max-h-96 object-cover rounded-lg border-4 border-white dark:border-gray-700 shadow-md hover:scale-102 transition-transform duration-300"
                />
                <p className="mt-4 text-center text-gray-600 dark:text-gray-300 italic">
                    {t("alevel.motherText")}
                </p>
            </div>

        </div>
    );
};

export default Organization;
